/* KINGSIGN enquiry attribution: no user identifiers, cookies, email, phone or click-ID values stored. */
(function () {
  'use strict';
  var STORAGE_KEY = 'kingsign_source_session_v1';
  function clean(v, length) {
    return String(v || '').replace(/[\x00-\x1f\x7f<>]/g, ' ').trim().slice(0, length || 100);
  }
  function readFirstTouch() {
    try {
      var saved = mayTrack() ? window.sessionStorage.getItem(STORAGE_KEY) : null;
      if (saved) {
        var parsed = JSON.parse(saved);
        if (parsed && parsed.source && parsed.landing) return parsed;
      }
    } catch (error) { /* Session storage might not be available. */ }

    var search = new URLSearchParams(window.location.search || '');
    var referrer = '';
    try {
      if (document.referrer) {
        var ref = new URL(document.referrer);
        if (ref.hostname !== window.location.hostname) referrer = ref.hostname;
      }
    } catch (error) { /* Ignore malformed referrer. */ }
    var googleClick = search.has('gclid') || search.has('gbraid') || search.has('wbraid');
    var bingClick = search.has('msclkid');
    var facebookClick = search.has('fbclid');
    var source = clean(search.get('utm_source') || (googleClick ? 'google' : bingClick ? 'bing' : facebookClick ? 'facebook' : referrer || 'direct_or_unknown'), 80);
    var searchReferrer = /(^|\.)(google\.[a-z.]+|bing\.com|yahoo\.com|duckduckgo\.com|baidu\.com)$/i.test(referrer);
    var medium = clean(search.get('utm_medium') || (googleClick || bingClick ? 'cpc' : facebookClick ? 'social_unknown' : searchReferrer ? 'organic_likely' : referrer ? 'referral' : 'not_set'), 80);
    var info = {
      source: source,
      medium: medium,
      campaign: clean(search.get('utm_campaign'), 100),
      landing: clean(window.location.pathname, 180),
      referrer: clean(referrer, 100)
    };
    try { if (mayTrack()) window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(info)); } catch (error) { /* Optional. */ }
    return info;
  }
  function updateForms() {
    var info = readFirstTouch();
    document.querySelectorAll('input[data-ks-enquiry-source]').forEach(function (field) {
      field.value = 'First source: ' + info.source +
        '; Medium: ' + info.medium +
        '; Campaign: ' + (info.campaign || 'not_set') +
        '; Entry page: ' + info.landing +
        '; Form page: ' + clean(window.location.pathname, 180) +
        '; External referrer: ' + (info.referrer || 'not_available');
    });
  }
  function mayTrack() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed();
    } catch (error) { return false; }
  }
  function emit(name, details) {
    if (!mayTrack()) return false;
    var publisher = window.Shopify && window.Shopify.analytics;
    if (!publisher || typeof publisher.publish !== 'function') return false;
    var data = Object.assign({page_path: clean(window.location.pathname, 180)}, details || {});
    try {
      var result = publisher.publish(name, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (error) { return false; }
  }
  function init() {
    updateForms();
    document.addEventListener('visitorConsentCollected', function () { updateForms(); });
    document.addEventListener('submit', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('input[data-ks-enquiry-source]')) updateForms();
    }, true);
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var channel = href.indexOf('mailto:') === 0 ? 'email' :
        href.indexOf('https://wa.me/') === 0 ? 'whatsapp' :
        href.indexOf('tel:') === 0 ? 'phone' :
        href.indexOf('#kingsign-online-enquiry-') === 0 ? 'online_enquiry_button' : '';
      if (channel) emit('ks_contact_intent_click', {contact_method: channel});
    }, true);
    var success = document.querySelector('[data-ks-enquiry-success]');
    if (success) {
      var key = 'kingsign_success_event_' + clean(window.location.pathname, 140);
      var previous = 0;
      try { previous = Number(window.sessionStorage.getItem(key) || 0); } catch (error) {}
      if (!previous || Date.now() - previous > 120000) {
        if (emit('ks_enquiry_form_success', {form_type: clean(success.getAttribute('data-ks-form-kind'), 40)})) {
          try { window.sessionStorage.setItem(key, String(Date.now())); } catch (error) {}
        }
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();